import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=63bc992d&scoped=true&"
import script from "./ContentCard.vue?vue&type=script&lang=ts&"
export * from "./ContentCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=63bc992d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc992d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
